import { Clock, CheckCircle, AlertTriangle } from 'lucide-react';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const statusConfig: Record<string, { label: string; icon: typeof Clock; colors: string }> = {
  pendente: {
    label: 'Pendente',
    icon: Clock,
    colors: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  },
  aprovado: {
    label: 'Aprovado',
    icon: CheckCircle,
    colors: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  revisao_solicitada: {
    label: 'Revisao Solicitada',
    icon: AlertTriangle,
    colors: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
};

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.pendente;
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${config.colors} ${className}`}>
      <Icon className="w-3.5 h-3.5" />
      {config.label}
    </span>
  );
}
